/**
 * Created by mykurisu on 2017/12/13.
 */
import React from 'react';
import {WKTag} from '../../components/wk'
import {renderMoney, TimeStream, isLZWKAPP, judgeAPPVersion} from '../../utils'
import {toChannel, toLecture} from '../../utils/connectApp'


class NewIntroItem extends React.Component {

    renderLectureTime() {
        const lecture = this.props.content;
        if (lecture.status === 'closed'){
            if (lecture.audio_length <= 5){
                return (
                    <p>{TimeStream(lecture.start_timestamp, 'YMD')}</p>
                )
            }else {
                return (
                    <p>时长<span>{lecture.audio_length}</span>分钟</p>
                )
            }
        }else {
            if (lecture.start_timestamp * 1000 < Date.parse(new Date())){
                return (
                    <p>{TimeStream(lecture.start_timestamp, 'YMD')}</p>
                )
            }else {
                let time = 0;
                if ((lecture.start_timestamp * 1000) - Date.parse(new Date()) >= 86400000){
                    time = TimeStream(lecture.start_timestamp,'-D') + '天后'
                }else {
                    time = TimeStream(lecture.start_timestamp,'-H') + '小时后'
                }
                return (
                    <p>{TimeStream(lecture.start_timestamp, 'YMD')}</p>
                )
            }
        }
    }

    renderLectureImageMode() {
        const lecture = this.props.content;
        if (lecture.image_mode === 'ppt' && lecture.lecture_mode === 'default'){
            return <WKTag text={'PPT'}/>;
        }
    }

    renderLectureTag() {
        const lecture = this.props.content;
        if (lecture.lecture_mode === 'default'){
            switch (lecture.image_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }
    }

    handleClick() {
        const {content, type, attr} = this.props;
        let link = '';
        if (isLZWKAPP()) {
            if (type === 'channel') {
                toChannel(content.id, 44813585)
            }
            if (type === 'lecture') {
                toLecture({ id: content.id, inviterId: '44813585', lectureMode: content.lecture_mode })
            }
            return
        }
        if (type){
            if (type === 'channel' && attr !== 'wk_intro'){
                link = `${content.url}&st=from_jx_small&kurisu=${this.props.kurisu}`
            }else if (type === 'channel' && attr === 'wk_intro'){
                link =  `/channel/${content.id}?st=${this.props.st}&inviter_id=43611198`
            }else if (type === 'lecture' && attr !== 'wk_intro'){
                link = `/lecture/${content.id}`
            }else if (attr === 'wk_intro' && type === 'lecture'){
                link = `/lecture/${content.id}?st=${this.props.st}&inviter_id=43611198`;
            }
        }
        window.location.href = link
    }

    renderPrice() {
        const {content} = this.props;
        if (content.need_money){
            if (content.has_limitmoney){
                if (Number(content.limit_money) === 0){
                    return <p><span>限时免费</span></p>
                }else {
                    if (isLZWKAPP() && judgeAPPVersion(400) && window.systemType === 'ios'){
                        return null
                    }else {
                        return <p>￥{content.limit_money.split('.')[0]}<span>.{content.limit_money.split('.')[1]}</span></p>
                    }
                }
            }else {
                if (isLZWKAPP() && judgeAPPVersion(400) && window.systemType === 'ios'){
                    return null
                }else {
                    return <p>￥{content.lecture_money.split('.')[0]}<span>.{content.lecture_money.split('.')[1]}</span></p>
                }
            }
        }else {
            return null
        }
    }

    render() {
        const {content, type, marginBottom, relayShow, attr} = this.props;
        return(
            <div className="new__introitem" onClick={() => this.handleClick()}>
                <div className="introitem__img" style={{backgroundImage: `url(${content.cover_url})`}}>

                </div>
                <div className="introitem__container">
                    <div className="introitem__title">
                        {content.is_preffered &&
                        <WKTag svgType={'yx'} text={'优选'} bgColor={'#F93D3A'} fontColor={'#fff'}/>
                        }
                        {type && type === 'lecture' &&
                        this.renderLectureTag()
                        }
                        {type && type === 'lecture' &&
                        this.renderLectureImageMode()
                        }
                        {relayShow && content.is_relay &&
                        '【转】'
                        }
                        {content.name}
                    </div>

                    <div>
                        <div className="introitem__price">
                            {this.renderPrice()}
                        </div>
                        <div className="introitem__message">
                            <div className="message__count">
                                {type && type === 'channel' &&
                                <p>已更新<span>{content.lecture_count}</span>期</p>
                                }
                                {(type && type === 'lecture') &&
                                this.renderLectureTime()
                                }
                            </div>
                            <div className="message__popular">
                                <span>{content.popular >= 10000 ? (content.popular / 10000).toFixed(2) + '万' : content.popular}</span>人气
                            </div>
                        </div>
                    </div>
                </div>
                <div className="introitem__enter">
                    马上学习
                </div>
            </div>
        )
    }
}

export default NewIntroItem



// WEBPACK FOOTER //
// ./src/pages/BestSubjectPage/NewIntroItem.js